export const personalized_recommend_content_type = {
    personalized_recommend_intent: 'personalized_recommend_intent', //个性化推荐--理解
    personalized_recommend_intent_reasoning: 'personalized_recommend_intent_reasoning', //个性化推荐-推理
    personalized_recommend_result: 'personalized_recommend_result', //个性化推荐-结果
    personalized_recommend_clarification: 'personalized_recommend_clarification', //澄清
    personalized_recommend_re_intent: 'personalized_recommend_re_intent', //个性化推荐-重新理解
    personalized_recommend_re_intent_reasoning: 'personalized_recommend_re_intent_reasoning', //重新理解-推理
    personalized_recommend_reasoning: 'personalized_recommend_reasoning', //个性化推荐-推理
    personalized_recommend_process: 'personalized_recommend_process', //个性化推荐-过程
    personalized_recommend_ask_reason: 'personalized_recommend_ask_reason', //个性化推荐-问题
    personalized_recommend_ask_reason_reasoning: 'personalized_recommend_ask_reason_reasoning' //个性化推荐-问题-推理
};
export const personalized_recommend_content_type_list = [
    personalized_recommend_content_type.personalized_recommend_intent,
    personalized_recommend_content_type.personalized_recommend_intent_reasoning,
    personalized_recommend_content_type.personalized_recommend_result,
    personalized_recommend_content_type.personalized_recommend_clarification,
    personalized_recommend_content_type.personalized_recommend_re_intent,
    personalized_recommend_content_type.personalized_recommend_re_intent_reasoning,
    personalized_recommend_content_type.personalized_recommend_reasoning,
    personalized_recommend_content_type.personalized_recommend_process,
    personalized_recommend_content_type.personalized_recommend_ask_reason,
    personalized_recommend_content_type.personalized_recommend_ask_reason_reasoning
];
